/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pkl_Lots_Col_ExpiryInputs */

const vi_pkl_lots_col_expiry = /** @type {(inputs: Pkl_Lots_Col_ExpiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HSD`)
};

/**

* @param {Pkl_Lots_Col_ExpiryInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pkl_lots_col_expiry = /** @type {((inputs?: Pkl_Lots_Col_ExpiryInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pkl_Lots_Col_ExpiryInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pkl_lots_col_expiry(inputs)
});